import * as Types from './Types';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'src/reducers/RootReducer';
import { ActionCreator, Dispatch } from 'react-redux';
import ApiClient from 'src/services/api-client/ApiClient';
import { AxiosResponse } from 'axios';
import Company from 'src/entities/Company';
import ValidatorService from 'src/services/validation/Validation.service';

export interface UpdateCompanyAttempt extends Action {
  type: Types.UPDATE_COMPANY_ATTEMPT;
}

export interface UpdateCompanySuccess extends Action {
  type: Types.UPDATE_COMPANY_SUCCESS;
}

export interface UpdateCompanyFailure extends Action {
  type: Types.UPDATE_COMPANY_FAILURE;
  payload: {};
}

export interface UpdateCompanyClearErrors extends Action {
  type: Types.UPDATE_COMPANY_CLEAR_ERRORS;
}

export type UpdateCompanyAction =
  UpdateCompanyAttempt |
  UpdateCompanySuccess |
  UpdateCompanyFailure |
  UpdateCompanyClearErrors;

export interface UpdateCompanyThunk extends ThunkAction<Promise<UpdateCompanyAction>, RootState, null> {
}

export const updateCompanyAttempt: ActionCreator<UpdateCompanyAttempt> = () => (
  {type: Types.UPDATE_COMPANY_ATTEMPT}
);

export const updateCompanySuccess: ActionCreator<UpdateCompanySuccess> = () => (
  {
    type: Types.UPDATE_COMPANY_SUCCESS,
  }
);
export const updateCompanyClearErrors: ActionCreator<UpdateCompanyClearErrors> = () => (
  {
    type: Types.UPDATE_COMPANY_CLEAR_ERRORS,
  }
);

export const updateCompanyFailure: ActionCreator<UpdateCompanyFailure> = (error: {}) => (
  {
    type: Types.UPDATE_COMPANY_FAILURE,
    payload: error
  }
);

export const updateCompany: ActionCreator<UpdateCompanyThunk> = (
  company: Company
): UpdateCompanyThunk => {

  return (dispatch: Dispatch<RootState>): Promise<UpdateCompanyAction> => {

    dispatch(updateCompanyAttempt());

    const validation = ValidatorService.validate([
      {value: company.name, message: 'name'},
      {value: company.cif, message: 'cifNumber'},
      {value: company.establishmentDate, message: 'establishmentDate'},
      {value: company.address, message: 'address'},
      {value: company.city, message: 'city'},
      {value: company.province, message: 'province'},
      {value: company.zipCode, message: 'zipCode'},
      {value: company.country, message: 'country'},
      {value: company.email, message: 'emailFormat', type: 'email'},
      {value: company.email, message: 'email'},
      {value: company.phoneNumber, message: 'phoneNumber'},
      {value: company.logo, message: 'logo'},
      {value: company.description, message: 'description'},
      {value: company.iban, message: 'iban'},
      {value: company.iban, type: 'iban'},
      {value: company.swiftBic, message: 'swiftBic'},
    ]);

    return validation.then(() => {
      return ApiClient.company.update(company.id, company)
        .then((response: AxiosResponse): UpdateCompanySuccess => {
          return dispatch(updateCompanySuccess());
        }).catch((e: { response: { data: { errors: {} } } }): UpdateCompanyFailure => {
          const errorMessages = ValidatorService
            .translateValidations(e && e.response && e.response.data && e.response.data.errors);

          return dispatch(updateCompanyFailure(errorMessages));
        });
    }).catch((errors) => {
      return dispatch(updateCompanyFailure(errors));
    });
  };
};

export const updateCompanyContactInformation: ActionCreator<UpdateCompanyThunk> = (
  company: Company
): UpdateCompanyThunk => {

  return (dispatch: Dispatch<RootState>): Promise<UpdateCompanyAction> => {

    dispatch(updateCompanyAttempt());

    const validation = ValidatorService.validate([
      {value: company.contactName, message: 'name'},
      {value: company.contactSurname, message: 'surname'},
      {value: company.contactNationality, message: 'nationality'},
      {value: company.contactNif, message: 'idNumber'},
      {value: company.contactBirthDate, message: 'birthDate', type: 'birthDate'},
      {value: company.contactEmail, message: 'emailFormat', type: 'email'},
      {value: company.contactEmail, message: 'email'},
      {value: company.contactPhoneNumber, message: 'phoneNumber'},
      {value: company.contactAddress, message: 'address'},
      {value: company.iban, type: 'iban'},
      {value: company.contactZipCode, message: 'zipCode'},
      {value: company.contactCity, message: 'city'},
      {value: company.contactProvince, message: 'province'},
      {value: company.contactCountry, message: 'country'},
    ]);

    return validation.then(() => {
      return ApiClient.company.update(company.id, company)
        .then((response: AxiosResponse): UpdateCompanySuccess => {
          return dispatch(updateCompanySuccess());
        }).catch((e: { response: { data: { errors: {} } } }): UpdateCompanyFailure => {
          const errorMessages = ValidatorService
            .translateValidations(e && e.response && e.response.data && e.response.data.errors);

          return dispatch(updateCompanyFailure(errorMessages));
        });
    }).catch((errors) => {
      return dispatch(updateCompanyFailure(errors));
    });
  };
};



// WEBPACK FOOTER //
// ./src/actions/company/update/UpdateCompany.actions.tsx